import { SET_SERVICE_URI } from "./types";

export async function setServiceUri({commit}, serviceUri) {
  commit(SET_SERVICE_URI, serviceUri);
  return serviceUri;
}